export default __webpack_public_path__ + "static/media/A596.b412ffd0.webp";